import { DataList, CustomModal } from 'commons-ui';
import React from 'react';
import { useStyletron } from 'styletron-react';

import updateReqConfig from './updateReqConfig';
import useZookeeperActions from '../../utils/useZookeeperActions';
import { makeUpdateReqsActionList } from '../../actions/list';
import { makeActionHandler } from '../../actions/handler';
import useUpdateReq from './useUpdateReq';

const UpdateReq: React.FC<{}> = () => {
	const { getActionHandler, getActionList } = useZookeeperActions(makeActionHandler, makeUpdateReqsActionList);
	const { fetchUpdateReqs, serviceName } = useUpdateReq();
	const [css] = useStyletron();
	const actions = getActionList();
	return (
		<div
			className={css({
				padding: '20px'
			})}>
			<div
				className={css({
					fontWeight: 'bold',
					fontSize: '32'
				})}>
				List of Pending Requests for {serviceName}
			</div>
			<div>
				<CustomModal />
				<DataList
					fetchData={fetchUpdateReqs}
					columnConfigs={updateReqConfig}
					getActionHandler={getActionHandler}
					actions={actions}
					rowHeight={100}
					entity='Services'
					initialSortDirection='ASC'
					initialSortIndex={1}
				/>
			</div>
		</div>
	);
};

export default UpdateReq;
